import React from "react";
import HotelGroupDropdown from "./Dropdown/HotelGroupDropdown";
import {Box} from "@mui/material";

const HotelGroupSelector = ({
    data,
    setSelectedCategory,
    selectedItem,
    setSelectedItem,
    selectedType,
    setSelectedType,
    setPage,
}) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2}}>
            <HotelGroupDropdown
                data={data}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                setSelectedCategory={setSelectedCategory}
                setPage={setPage}
            />
        </Box>
    );
};

export default HotelGroupSelector;
